import React, { useState } from "react";
import axios from "axios";
import { useParams, useNavigate , Link } from "react-router-dom";
import { ApiUrl } from "../Constants/Weburl";
import { FaLock } from 'react-icons/fa';


// export default function ResetPassword() {
//   const { token } = useParams();
//   const navigate = useNavigate();
//   const [password, setPassword] = useState("");
//   const [confirm, setConfirm] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [msg, setMsg] = useState("");
//   const [error, setError] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setMsg(""); setError("");

//     if (password !== confirm) return setError("Passwords do not match");

//     try {
//       setLoading(true);
//       const res = await axios.post(`${ApiUrl}api/auth/reset-password/${token}`, { password });
//       setMsg(res.data.message);
//       setTimeout(() => navigate("/"), 2000); 
//     } catch (err) {
//       setError(err.response?.data?.message || "Something went wrong");
//     }
//     setLoading(false);
//   };

//   return (
//     <div style={{ maxWidth: 400, margin: "80px auto", padding: 24 }}>
//       <h3>Reset Password</h3>
//       <form onSubmit={handleSubmit}>
//         <input
//           type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
//           placeholder="New password" style={{ width: "100%", padding: 10, marginBottom: 12 }}
//         />
//         <input
//           type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
//           placeholder="Confirm password" style={{ width: "100%", padding: 10, marginBottom: 12 }}
//         />
//         <button type="submit" disabled={loading} style={{ width: "100%", padding: 10 }}>
//           {loading ? "Saving..." : "Change Password"}
//         </button>
//       </form>
//       {msg && <p style={{ color: "green", marginTop: 12 }}>{msg}</p>}
//       {error && <p style={{ color: "red", marginTop: 12 }}>{error}</p>}
//     </div>
//   );
// }


export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");

    if (password !== confirm) {
      return setError("Passwords do not match");
    }

    try {
      setLoading(true);

      const res = await axios.post(
        `${ApiUrl}api/auth/reset-password/${token}`,
        { password }
      );

      setMsg(res.data.message);

      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      setError(
        err.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-page">
      <div className="reset-card">

        <div className="reset-icon">
          {/* <svg
            width="35"
            height="35"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#f9a825"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="4" y="10" width="16" height="11" rx="2" />
            <path d="M8 10V7a4 4 0 0 1 8 0v3" />
            <path d="M12 14v3" />
          </svg> */}
          <FaLock size={24} color="#f9a825" />
        </div>

        <p className="reset-label">ADMIN PORTAL</p>

        <h2>Create new password</h2>

        <p className="reset-description">
          Choose a strong password to keep your account secure.
          Enter your new password below.
        </p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="new-password">New password</label>

          <div className="reset-input-wrap">
            <FaLock size={18} color="#4A5568" />

            <input
              id="new-password"
              type={showPassword ? "text" : "password"}
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter new password"
              autoComplete="new-password"
              disabled={loading}
            />

            <button
              type="button"
              className="reset-eye"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              disabled={loading}
            >
              {showPassword ? (
                <svg width="20" height="20" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M3 3l18 18" />
                  <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8" />
                  <path d="M9.9 5.2A10.8 10.8 0 0 1 12 5c5 0 8.5 5 9 7a11.8 11.8 0 0 1-3 4.3" />
                  <path d="M6.2 6.2C3.8 7.8 2.3 10.2 2 12c.5 2 4 7 10 7 1 0 2-.2 2.8-.5" />
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              )}
            </button>
          </div>

          <label htmlFor="confirm-password" className="reset-confirm-label">
            Confirm password
          </label>

          <div className="reset-input-wrap">
           <FaLock size={18} color="#4A5568" />

            <input
              id="confirm-password"
              type={showConfirm ? "text" : "password"}
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Re-enter new password"
              autoComplete="new-password"
              disabled={loading}
            />

            <button
              type="button"
              className="reset-eye"
              onClick={() => setShowConfirm(!showConfirm)}
              aria-label={showConfirm ? "Hide password" : "Show password"}
              disabled={loading}
            >
              {showConfirm ? (
                <svg width="20" height="20" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M3 3l18 18" />
                  <path d="M9.9 5.2A10.8 10.8 0 0 1 12 5c5 0 8.5 5 9 7a11.8 11.8 0 0 1-3 4.3" />
                  <path d="M6.2 6.2C3.8 7.8 2.3 10.2 2 12c.5 2 4 7 10 7 1 0 2-.2 2.8-.5" />
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              )}
            </button>
          </div>

          <div className="reset-password-hint">
            <span>ⓘ</span>
            Make sure both passwords match before continuing.
          </div>

          {msg && (
            <div className="reset-alert reset-success" role="status">
              <span>✓</span>
              <p>{msg}</p>
            </div>
          )}

          {error && (
            <div className="reset-alert reset-error" role="alert">
              <span>!</span>
              <p>{error}</p>
            </div>
          )}

          <button
            type="submit"
            className="reset-submit"
            disabled={loading || !!msg}
          >
            {loading ? (
              <>
                <span className="reset-spinner" />
                Updating password...
              </>
            ) : (
              <>
                Change password
                <span className="reset-arrow">→</span>
              </>
            )}
          </button>
        </form>

        <div className="reset-divider">
          <span />
          <span>SECURE ADMIN ACCESS</span>
          <span />
        </div>

        <Link to="/" className="reset-back">
          <span>←</span> Back to Login
        </Link>

      </div>

      <p className="reset-footer">
        © {new Date().getFullYear()} Admin Portal. All rights reserved.
      </p>
    </div>
  );
}
